export default __webpack_public_path__ + "static/media/likes-grey.b3b07d6d.svg";